import { useEffect } from "react"

type ConfirmDialogProps = {
   message: string
   onConfirm: () => void
   onCancel: () => void
}

export function ConfirmDialog({ message, onConfirm, onCancel }: ConfirmDialogProps) {
   useEffect(() => {
      const modal = document.getElementById("confirm_modal") as HTMLDialogElement
      if (modal) {
         modal.showModal()
      }
   }, [])

   return (
      <dialog id="confirm_modal" className="modal  modal-middle">
         <div className="modal-box">
            <p className="py-4">{message}</p>
            <div className="modal-action">
               <form method="dialog">
                  <div className="flex gap-2">
                     <button className="btn btn-outline" onClick={onCancel}>
                        Non
                     </button>
                     <button className="btn btn-primary" onClick={onConfirm}>
                        Oui
                     </button>
                  </div>
               </form>
            </div>
         </div>
         <form method="dialog" className="modal-backdrop">
            <button onClick={onCancel}>close</button>
         </form>
      </dialog>
   )
}
